import { Property } from '@app/react-common/components/rule-engine-v2/models/RuleEngineConfig';
import { Option } from '@app/react-common/components/dropdown/Dropdown';
import { SourceToDisplayOn } from '@pdqdev/pdq-shared/dist/entities';
import { mapValuesToDropdownOptions } from '@pdqdev/pdq-shared/dist/utils';
import { locales } from '@pdqdev/pdq-shared/dist/utils/locale';

const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const TIME_OF_DAY_OPTIONS: Option[] = [
  { label: 'Morning (06:00-11:59 AM)', value: 'morning' },
  { label: 'Noon (12:00-05:59 PM)', value: 'noon' },
  { label: 'Evening (06:00-11:59 PM)', value: 'evening' },
  { label: 'Night (12:00-05:59 AM)', value: 'night' },
];
const GENDERS = ['Male', 'Female'];
const BOOLEANS = ['True', 'False'];
const SUBSCRIPTIONS = ['In the cart'];

export const ValueDropdownOptions: Partial<Record<Property, Option[]>> = {
  [Property.subscription]: mapValuesToDropdownOptions(SUBSCRIPTIONS, { valToSnakeCase: true }),
  [Property.source]: [
    { label: 'Checkout only', value: SourceToDisplayOn.CHECKOUT_PAGE_ONLY },
    { label: 'Product page only', value: SourceToDisplayOn.PRODUCT_PROMISE_PAGE_ONLY },
  ],
  [Property.weekday]: mapValuesToDropdownOptions(WEEKDAYS),
  [Property.hasACoupon]: mapValuesToDropdownOptions(BOOLEANS),
  [Property.gender]: mapValuesToDropdownOptions(GENDERS, { valOnlyFirstLetter: true, valToLowerCase: false }),
  [Property.locale]: locales,
  [Property.timeOfDay]: TIME_OF_DAY_OPTIONS,
};
